enum PopheadzCampaignTab {
  Team = "Team",
}

export default PopheadzCampaignTab;
